import {
    ListItem,
    Box,
    Typography,
    ListItemText,
    ListItemAvatar,
    Skeleton
} from '@mui/material';

export function ReviewListSkeleton() {
    return [...Array(3)].map((_, index) => (
        <Box key={index}>
            <ListItem dense disablePadding alignItems="flex-start">
                <ListItemAvatar>
                    <Skeleton variant="circular" width={40} height={40} />
                </ListItemAvatar>
                <ListItemText
                    primary={<Skeleton width="30%" height={20} />}
                    secondary={
                        <Box component="span">
                            <Typography sx={{ fontSize: 14, display: 'block' }} component="span" variant="body2" color="text.secondary" gutterBottom>
                                <Skeleton width="25%" height={16} />
                            </Typography>
                            <Skeleton width="40%" height={24} />
                            <Skeleton width="80%" height={16} />
                        </Box>
                    }
                />
            </ListItem>
        </Box>
    ));
}